import { render } from "./TypographyComponent.vue?vue&type=template&id=0a1d9c8b&scoped=true&ts=true"
import script from "./TypographyComponent.vue?vue&type=script&lang=ts"
export * from "./TypographyComponent.vue?vue&type=script&lang=ts"

import "./TypographyComponent.vue?vue&type=style&index=0&id=0a1d9c8b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1d9c8b"]])

export default __exports__